
export  default function getCurrentMonthStart(){    
    var today = new Date();
    today.setDate(1);

    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
      
    return yyyy + '-' + mm + '-' + dd;
}